import classes from "./Integrations.module.css";
import WhitePlusIcon from "../../images/deliveries/whitePlusIcon.svg";
import { EyeSlash } from "../../images/EyeSlash";
import { ActionBtn } from "../../components/buttons/actionBtn/ActionBtn";
import { BaseTable } from "../../components/UI/baseTable/BaseTable";
import { PageWrapper } from "../../components/UI/pageWrapper/PageWrapper";
import { CustomerDrafts } from "./CustomerDrafts";
import { getIntegrations } from "../../redux/integrations/getIntegrations";
import { useTranslations } from "../../helperFunctions/customHooks/useTranslations";
import { NavToggleButton } from "../../components/buttons/navToggleBtn/NavToggleBtn";
import { useEffect, useState } from "react";
import { setIsGenerateApiShown } from "../../redux/globalFunctions/globalFnSlice";
import { useDispatch, useSelector } from "react-redux";

export function Integrations() {
  const dispatch = useDispatch();

  const { integrations, status } = useSelector(
    (state) => state.getIntegrations
  );
  const { t } = useTranslations();
  const text = t.integrations;

  useEffect(() => {
    dispatch(getIntegrations());
  }, []);

  const { status: generateStatus } = useSelector(
    (state) => state.generateApiKey
  );

  useEffect(() => {
    if (generateStatus === "success") {
      dispatch(getIntegrations());
    }
  }, [generateStatus]);

  function handleGenerateClick() {
    dispatch(setIsGenerateApiShown(true));
  }

  const columns = [
    { label: text.name },
    { label: text.apiKey },
    { label: text.purpose },
    { label: text.date },
  ];

  const [isIntegrationsTab, setIsIntegrationsTab] = useState(true);

  const buttons = [
    <ActionBtn
      onClick={handleGenerateClick}
      text={text.generateKey}
      imgSrc={WhitePlusIcon}
      height={"42px"}
    />,
  ];

  const navButtons = [
    <NavToggleButton
      isActive={isIntegrationsTab}
      onClick={() => setIsIntegrationsTab(true)}
      text={"Integrations"}
    />,
    <NavToggleButton
      isActive={!isIntegrationsTab}
      onClick={() => setIsIntegrationsTab(false)}
      text={"Customers"}
    />,
  ];

  return (
    <PageWrapper
      navButtons={navButtons}
      buttons={isIntegrationsTab ? buttons : []}
    >
      {isIntegrationsTab ? (
        <>
          <BaseTable
            resultsContainerHeight={"calc(100vh - 285px)"}
            header={text.allKeys}
            status={status}
            errorMsg={text.errorFetching}
            noItemsMsg={text.noIntegrations}
            items={integrations}
            columns={columns}
            columnAndRowWidth={"200px"}
            rows={
              integrations &&
              integrations?.map((item) => [
                item.key_name,
                <div className={classes.keyContainer}>
                  {"*****"}
                  <EyeSlash />
                </div>,
                item.key_description,
                "21.21.2022",
              ])
            }
          />
        </>
      ) : (
        <CustomerDrafts />
      )}
    </PageWrapper>
  );
}
